export default __webpack_public_path__ + "static/media/star2.7df74721.gif";